import * as React from 'react';

export default {
  AdminApp: React.lazy(
    () =>
      import(
        /* webpackChunkName: "phc-admin" */
        '../AdminApp'
      ),
  ),
};
